import { useEffect, useRef, useState } from "react";
import { Stage, Layer, Rect, Circle, Image } from "react-konva";
import Marking from "./Marking";
import ProblemMarking from "./ProblemMarking";
import useImage from "use-image";

const screenHeightRatio = 9 / 16;

const ImageCanvas = (props) => {
  const {
    imageUrl,
    markings,
    onChangeKordinat,
    type,
    disabled,
    // read-only reference dots for the open problems of this group (where they were found), so they can be
    // told apart from this trip's own markings
    problemMarkings,
    // id of the problem picked in the problem list, its marker is drawn highlighted
    highlightedProblemId,
    // { [problem id]: true } of the problems that were checked: their marker is green
    resolvedProblemIds,
  } = props;
  const bgDivRef = useRef(null);

  const [size, setSize] = useState({ width: 1, height: 1 });

  // const [markings, setMarkings] = useState([
  //   { id: 1, marking_warna: "rgba(255, 0, 0, 0.5)", marking_kordinat: "0,0" },
  //   { id: 2, marking_warna: "rgba(0, 0, 255, 0.5)", marking_kordinat: "80,50" },
  // ]);

  useEffect(() => {
    if (bgDivRef.current) {
      const boundingRect = bgDivRef.current.getBoundingClientRect();
      const { width, height } = boundingRect;
      setSize({ width: Math.round(width), height: Math.round(height) });
    }
  }, [bgDivRef, bgDivRef.current]);

  //   console.log("SIZE", size);
  //   console.log(size.width * screenHeightRatio);

  return (
    <div ref={bgDivRef} className="col-start-start relative bg-red-100 w-full">
      <img
        src={imageUrl}
        alt="gambar"
        className={`absolute top-0 left-0 object-fill w-full h-full`}
      />
      {size.width > 50 && (
        <Stage
          width={size.width}
          height={Math.floor(size.width * screenHeightRatio)}
        >
          <Layer>
            {/* the open problems of this group, where they were found (read-only, drawn under this trip's markings) */}
            {(problemMarkings || [])
              .filter((el) => !!el.marking_kordinat)
              .map((el) => (
                <ProblemMarking
                  key={`problem-${el.id}`}
                  parent_width={size.width}
                  parent_height={size.height}
                  data={el}
                  highlighted={el.id === highlightedProblemId}
                  resolved={!!(resolvedProblemIds && resolvedProblemIds[el.id])}
                />
              ))}
            {markings.map((el, index) => {
              return (
                <Marking
                  key={`${el.id}-${Math.random().toString(36).substr(2, 9)} `}
                  type={type}
                  parent_width={size.width}
                  parent_height={size.height}
                  data={el}
                  index={el.urutan}
                  onChangeKordinat={onChangeKordinat}
                  disabled={disabled}
                />
              );
            })}
          </Layer>
        </Stage>
      )}
    </div>
  );
};

export default ImageCanvas;
